import dados from "./assuntos.json";
import type { Assunto } from "./tipos";
import { publicavel } from "./tipos";

/**
 * Os assuntos, lidos de assuntos.json.
 *
 * Mora em JSON pelo mesmo motivo do videos.json: o scripts/prerender.mjs
 * roda em Node puro, sem TypeScript, e precisa da mesma lista para escrever
 * o HTML de cada página. Duas listas acabariam divergindo no dia em que
 * alguém acrescentasse um assunto e esquecesse a outra.
 */

const TODOS = dados.assuntos as readonly Assunto[];

/** Só o que tem fonte vai ao ar. O resto fica no arquivo, invisível. */
export const ASSUNTOS: readonly Assunto[] = TODOS.filter(publicavel);

/** Inclusive os não publicados. */
export const ASSUNTOS_TODOS: readonly Assunto[] = TODOS;

export function acharAssunto(slug: string): Assunto | undefined {
  return ASSUNTOS.find((a) => a.slug === slug);
}
